import { memo } from 'react';
import { CellProps } from '../../types';
import { CellEventsHandler } from '../formatters';
import { centerHeaderRenderer } from '../headers';
import { IColumn } from '../types';

const Formatter = memo(function formatter(cellProps: CellProps) {
  return <CellEventsHandler cellProps={cellProps}>{cellProps.row.followUpDocumentComplete || ''}</CellEventsHandler>;
});

export const FollowUpDocsColumn = (): IColumn => ({
  item: {
    key: 'followUpDocumentComplete',
    name: 'Follow up docs',
    width: 'minmax(104px, .5fr)',
    headerRenderer: centerHeaderRenderer,
    sortable: true,
    formatter: Formatter,
  },
  visible: ({ isFollowUpDocsCountVisible }) => isFollowUpDocsCountVisible!,
});
